import {
    prop,
    isArray,
    map
} from "../../common/utils";

function _getCity(state, id) {
    return prop(state._addressMap, id, null)
}

function _getSubCityIds(state, pid) {
    const A = prop(state._addressTree, pid, null)
    return isArray(A) ? A : []
}

// 获取城市信息
export function getCity(state) {
    return (id) => _getCity(state, id)
}

export function subCityList(state) {
    return (pid) => map(_getSubCityIds(state, pid), id => _getCity(state, id))
}

// 获取城市名
export function getCityName(state) {
    return (id) => prop(_getCity(state, id), 'name', `city_${id}`)
}
